import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=e67fd81a&"
import script from "./Teachers.vue?vue&type=script&lang=ts&"
export * from "./Teachers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports